import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "doc-list" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PButton = _resolveComponent("PButton")!
  const _component_doc_preview_component = _resolveComponent("doc-preview-component")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_PButton, {
      title: "Подписать документ",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openWiz()))
    }),
    _createElementVNode("div", _hoisted_1, [
      (_ctx.hasPhone && _ctx.loadRes)
        ? (_openBlock(), _createBlock(_component_doc_preview_component, { key: 0 }))
        : _createCommentVNode("", true)
    ])
  ], 64))
}